import { createClient } from '@sanity/client';

export default createClient({
    projectId: 'oi21ks1a',
    dataset: 'production',
    apiVersion: '2022-03-07',
    token: "skywfF08JltKL8JpNCbaAtIEmVv8bjreBKehs73JJgydxkStZxMe8TNyPXFaW5QocfJvIktIiEjJzMEhpwYixfxJ4ZltXL7UzxkEuE7dGdlwXX6CKKAsCBD26lS0caZDuAGYZmw8yiwQC4XiJGj6qpaXRsRCW3xjrf1b9esag0kHDpScgdUO",
    ignoreBrowserTokenWarning: true
})